import React from "react";

import header1 from "../../assets/img/header-bg1.jpg";
import header2 from "../../assets/img/header-bg2.jpg";
import header3 from "../../assets/img/header-bg3.jpg";
import header4 from "../../assets/img/header-bg4.jpg";
import header5 from "../../assets/img/header-bg5.jpg";
import header6 from "../../assets/img/header-bg6.jpg";
import gambit from "../../assets/img/header-gambit.jpg";
import cirilla from "../../assets/img/header-cirilla.jpg";
import figment from "../../assets/img/header-figment.jpg";
import venus from "../../assets/img/header-venus.jpg";
import nimona from "../../assets/img/header-nimona.jpg";
import squeeze from "../../assets/img/header-squeeze.jpg";
import rumi from "../../assets/img/header-rumi.jpg";
import vh2022 from "../../assets/img/dogs/litters/vh2022/header2.jpg";
import vr2023 from "../../assets/img/dogs/litters/vr2023/header.jpg";
import vh2025 from "../../assets/img/dogs/litters/vh2025/header2.jpg";
import nj2025 from "../../assets/img/header-nj2025.jpg";
import vr2027 from "../../assets/img/header-vr2027.jpg";
import sf2027 from "../../assets/img/header-sf2027.jpg";

// core components

class LandingPageHeader extends React.Component {
  render() {
    let pageHeader = React.createRef();
    const components = {
      header1: header1,
      header2: header2,
      header3: header3,
      header4: header4,
      header5: header5,
      header6: header6,
      gambit: gambit,
      cirilla: cirilla,
      figment: figment,
      venus: venus,
      nimona: nimona,
      squeeze: squeeze,
      rumi: rumi,
      vh2022: vh2022,
      vh2025: vh2025,
      vr2023: vr2023,
      nj2025: nj2025,
      vr2027: vr2027,
      sf2027: sf2027,
    };
    const headerUrl = components[this.props.bg];
    const { children, hideText, title, subtitle } = this.props;

    const sectionStyle = {
      backgroundImage: `url(${headerUrl})`
    };

    return (
        <>
          <div className="page-header page-header-small no-overlay site-page-hero">
            <div
                className="page-header-image site-page-hero-image"
                style={sectionStyle}
                ref={pageHeader}
            ></div>
            {title || subtitle || children ? (
              <div className={`container site-page-hero-content${hideText ? " site-page-hero-content-hidden" : ""}`}>
                {children}
                {title && <h1>{title}</h1>}
                {!hideText && <span aria-hidden="true"></span>}
                {subtitle && <p>{subtitle}</p>}
              </div>
            ) : null}
          </div>
        </>
    );
  };
}

export default LandingPageHeader;
